import * as React from 'react';
import { MdAdd } from 'react-icons/md';
import { AddButton, Options } from 'ui';
import { SelectMultiple } from 'app/area/shared/translated-components';
import { OpenStateInjectedProps, withOpenState } from 'ui/common/enhancers/with-open-state';
import { CloseOnBlur } from 'ui/common/close-on-blur';
import { DialogExpander } from 'ui/common/dialog-expander/dialog-expander';
import { ComplexValue } from 'app/types-shared';
import { keyCodeTypes } from 'ui/common/key-code-types';
import { Handlers, HotKeys, KeyMap } from 'ui/common/hotkeys';

export interface RecipientSelectorProps extends Options<string> {
  textAddItem?: string;
  textDone?: string;
  textCodeSelectorTitle?: string;
  placeholderSearch?: string;
  onClose?: (values: ComplexValue<string>[]) => void;
  searchRequired?: boolean;
}

interface RecipientSelectorPropsState {
  selectedItems: ComplexValue<string>[];
}

class EmailRecipientsSelectComponent
  extends React.PureComponent<RecipientSelectorProps & OpenStateInjectedProps, RecipientSelectorPropsState> {
  private keyMap: KeyMap;
  private handlers: Handlers;

  public constructor(props: RecipientSelectorProps & OpenStateInjectedProps) {
    super(props);
    this.state = {
      selectedItems: []
    };

    this.keyMap = {
      handleClose: [keyCodeTypes.Esc],
      handleEnter: [keyCodeTypes.Enter]
    };

    this.handlers = {
      handleClose: this.onClose,
      handleEnter: this.onClose
    };
  }

  private onCodesSelected = (codes: ComplexValue<string>[]) => {
    this.setState({
      selectedItems: codes
    });
  };

  private clearSelectedItems = () => {
    if (this.props.isOpen) {
      this.setState({
        selectedItems: []
      });
    }
  };

  private onConfirm = () => {
    this.props.onClose(this.state.selectedItems);
    this.clearSelectedItems();
  };

  private onClose = () => {
    const { close } = this.props;

    this.onConfirm();    
    close();
  };

  private openCodeSelector = () => {
    if (!this.props.isOpen) {
      this.props.open();
    }
  };

  private renderCodeSelector() {
    const {
      textDone,
      textCodeSelectorTitle,
      options,
      onLoadOptions,
      fetching,
      loadOptions,
      loadOptionsError,
      placeholderSearch,
      isClosing,
      searchRequired,
      locale
    } = this.props;

    const closingAnimation = isClosing ? 'animate-out': '';

    return (
      <div className={closingAnimation}>
        <DialogExpander
          onClose={this.onClose}
          title={textCodeSelectorTitle}
          textDone={textDone}
          selectExpander={true}>
          <SelectMultiple
            componentId={'select-email-recipients'}
            className={'select-email-recipients'}
            placeholder={placeholderSearch}
            hideAlphabeticIndex={false}
            options={options}
            valueItems={this.state.selectedItems}
            onChange={this.onCodesSelected}
            alwaysOpen={true}
            fetching={fetching}
            loadOptions={loadOptions}
            onLoadOptions={onLoadOptions}
            loadOptionsError={loadOptionsError}
            searchRequired={searchRequired}
            locale={locale}
          />
        </DialogExpander>
      </div>
    );
  }

  public render() {
    const { isOpen, textAddItem } = this.props;

    return (
      <CloseOnBlur onBlur={this.onClose}>
        <HotKeys keyMap={this.keyMap} handlers={this.handlers}>  
          <div >            
            <AddButton icon={MdAdd}
              onClick={this.openCodeSelector}>
              {textAddItem}
            </AddButton>            
            {isOpen && this.renderCodeSelector()}
          </div>
        </HotKeys>
      </CloseOnBlur>
    );
  }
}

const emailRecipientsSelectComponent = withOpenState(true)(EmailRecipientsSelectComponent);

export { emailRecipientsSelectComponent as EmailRecipientsSelector };
